<template>
  <div>
    <header class="menu">
      <section class="top">
        <a href="./"
          ><img src="/static/img/app/logo_gorsh.svg?v=1.0" class="logo"
        /></a>

        <div class="anchors text-right">
          <ul class="list-inline">

            <li class="">
              <a class="openSearch" @click.prevent="openSearch()">
                <!-- <router-link :to="'/search/luz'"> -->
                  <i class="fa fa-search"></i><span class="hidden-xs hidden-sm"> &nbsp; Buscar</span>
                <!-- </router-link> -->
              </a>
            </li>

            <li class="dropdown left-line">
              <!-- hidden-xs hidden-sm -->
              <a
                class="dropdown-toggle"
                data-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div class="hidden-xs hidden-sm">
                  {{ user.email }} &nbsp; <i class="fa fa-angle-down"></i>
                </div>
                <div class="visible-xs visible-sm">
                  <i class="fa fa-user"></i>
                </div>
              </a>

              <div class="dropdown-menu dropdown-menu-right">
                <!--<a class="dropdown-item" href="./mis-datos">Mi Cuenta</a>-->
                <router-link class="dropdown-item" to="/myorders"
                  >Mis Compras</router-link
                >

                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" @click.prevent="logout"
                  >Salir</a
                >
              </div>
            </li>
            <li>
              <a class="openMyCart" @click="openMyCart">
                <i class="fa fa-shopping-cart"></i> &nbsp;
                <span class="">
                  <span class="cantidad" v-if="cart_total > 0"
                    >{{ cart_items.length }} prod.</span
                  >
                  <span class="cantidad hidden-xs hidden-sm" v-else
                    >Sin productos</span
                  >
                </span>
              </a>
            </li>

          
          

          </ul>
        </div>
      </section>

      <section class="bottom">
        <ul>
          <li>
            <router-link to="/">HOME</router-link>
          </li>

          <li v-for="category in categories" :key="category.id">
            <router-link :to="'/category/' + category.id">{{
              category.nombre
            }}</router-link>
          </li>
        </ul>
      </section>
    </header>

    <div class="compensate-header"></div>


    <div class="box-search">
        <div class="table">
            <div class="cell">

                <a class="closeSearch" @click.prevent="closeSearch()">
                    <img src="/static/img/app/btn-close-white.svg">
                </a>
                
                <input id="search" v-model="searchInput" name="search" class="search required" type="search" 
                    placeholder="¿Qué estás buscando?" value="" @keyup.enter="doSearch()">
                <br>
                <div class="btn-primary-ecommerce btn-buscar line inverted" @click.prevent="doSearch()" >
                    ¡BUSCAR!
                </div><br>
                <div class="btn-cancel" @click.prevent="closeSearch()">
                  cancelar 
                </div>

            </div>
        </div>
    </div>

  </div>
</template>

<script>
import Api from "@/Api";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      categories: [],
      searchInput: ''
    };
  },
  computed: {
    ...mapGetters(["user", "isLogged", "cart_total", "cart_items"])
  },
  methods: {

    doSearch () {
      if( this.searchInput != '' )
        this.$router.push('/search/'+this.searchInput);
        this.closeSearch();
    },
    
    openSearch(){
        $(".box-search").addClass("open");
        $("body").addClass("lock");
        $(".box-search input.search").focus();
    },
    closeSearch(){
        $(".box-search").removeClass("open");
        $("body").removeClass("lock");
    },
    
    openMyCart() {
      $("nav.micarrito, .overlay-micarrito").addClass("open");
      $("body").addClass("lock");
    },
    logout() {
      this.$store
        .dispatch("logout", this)
        .then(() => {
          this.$router.push({ name: "Login" });
        })
        .catch(err => {});
    }
  },
  mounted() {
    Api()
      .get("?func=getHeaderCategories")
      .then(data => {
        if (data.data.success) {
          this.categories = data.data.payload.categories;
        } else {
          this.categories = [];
        }
      })
      .catch(err => {});
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/HeaderPartial.vue